// B-47 — the readable names of a business's cierre keys, fetched once and shared.
//
// They arrive with `getExtractionFields` (`names`, from the backend's per-client
// `panel/names/<client>.yaml`). Every Cierres screen asks for them; the promise is kept per
// business and client so the detail dialog, the worksheet and the alert feed make one request
// between them.
//
// B-55 — the client is part of the key, not just of the request. The dictionary is that client's
// own file, so a business with two clients caching under one key would label Bancamia's panel
// with Davivienda's words and never ask again.
//
// A failed or empty answer yields `NOMBRES_VACIOS`, and every label then falls back to the
// prettified key — the screen still works, it just reads the way it did before B-47.

import { useEffect, useState } from "react";
import { getExtractionFields } from "../ApiCalls/mantisBusiness";
import { NOMBRES_VACIOS } from "../utils/cierreNombres";

const enCurso = new Map();

const cargarNombres = (token, mantisBusinessId, clientCode) => {
  const clave = `${mantisBusinessId}:${clientCode || ""}`;
  if (!enCurso.has(clave)) {
    const promesa = getExtractionFields(token, mantisBusinessId, clientCode)
      .then((respuesta) => (respuesta?.success && respuesta.names ? respuesta.names : NOMBRES_VACIOS))
      .catch(() => NOMBRES_VACIOS)
      .then((nombres) => {
        // An empty answer is not cached: the next screen to open asks again instead of being
        // stuck with prettified keys for the rest of the session over one failed request.
        if (nombres === NOMBRES_VACIOS) enCurso.delete(clave);
        return nombres;
      });
    enCurso.set(clave, promesa);
  }
  return enCurso.get(clave);
};

export function useNombresCierre(token, mantisBusinessId, clientCode) {
  const [nombres, setNombres] = useState(NOMBRES_VACIOS);

  useEffect(() => {
    // Waiting for the client is the same guard the screens apply to their own fetch, and for the
    // same reason: asking before it arrives is a request the backend answers 400 to on a business
    // with two cierre clients, and a second one once the code shows up. `NOMBRES_VACIOS` is
    // already what this returns while it waits, so nothing on screen is missing in the meantime.
    if (!mantisBusinessId || !clientCode) return undefined;
    let vigente = true;
    cargarNombres(token, mantisBusinessId, clientCode).then((cargados) => {
      if (vigente) setNombres(cargados);
    });
    return () => {
      vigente = false;
    };
  }, [token, mantisBusinessId, clientCode]);

  return nombres;
}
